import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Link,
  List,
  ListItem,
  Modal,
  ModalTrigger,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";

interface ModalContents {
  modalTitle: string;
  modalBodyTitle: string;
  modalBody: string[];
}

export function ModalLinkControl(props: ArrayControlProps) {
  const { t } = useTranslation();
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);

  const modalContent: ModalContents = props?.uischema?.options?.modalContents;

  if (isSummaryForPath?.(props.path) || !modalContent) {
    return null;
  }

  return (
    <ModalTrigger
      trigger={
        <>
          <Link
            testID="what-not-to-declare-modal-link"
            linkStyle="monochrome"
            textStyle="form/body-secondary-link"
          >
            {props.uischema.label as string}
          </Link>
        </>
      }
    >
      <Modal>
        <Dialog>
          {({ close }) => (
            <>
              <DialogHeader>{modalContent.modalTitle}</DialogHeader>
              <DialogContent>
                <div>
                  <Text style="global/body-primary" color="text-base">
                    {modalContent.modalBodyTitle}
                  </Text>

                  <br />
                  <br />

                  <List type="unordered">
                    {modalContent.modalBody.map((item, i, array) => {
                      const removeListStyleType = Array.isArray(array[i]);
                      return (
                        <ListItem
                          removeListStyleType={removeListStyleType}
                          key={i}
                        >
                          {Array.isArray(item) ? (
                            <List type="unordered">
                              {item.map((item, i) => {
                                return (
                                  <ListItem key={i}>
                                    <Text
                                      style="global/body-primary"
                                      color="text-base"
                                    >
                                      {item}
                                    </Text>
                                  </ListItem>
                                );
                              })}
                            </List>
                          ) : (
                            <Text style="global/body-primary" color="text-base">
                              {item}
                            </Text>
                          )}
                        </ListItem>
                      );
                    })}
                  </List>
                </div>
              </DialogContent>
              <DialogFooter>
                <PrimaryButton onPress={close}>{t("Close")}</PrimaryButton>
              </DialogFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </ModalTrigger>
  );
}

export const TextModalControlRenderer =
  withJsonFormsArrayControlProps(ModalLinkControl);
